module.exports = __webpack_public_path__ + "static/media/iAuditor-icon.7f4e98ac.svg";